module.exports = __webpack_public_path__ + "static/media/compass.f3a70978.png";